import React, {useEffect, useRef, useState} from 'react';
import {cloneDeep, get, isArray} from "lodash";
import {DynamicDataSheetGrid, keyColumn} from "react-datasheet-grid";
import {ContextMenu} from "./ContextMenu";
import {createAddRowsComponent, onCopyValueDateTracking, onCopyValueText} from "./TableOrderUtils";
import {getExistLangValue, getLangInStorage, translate} from "../../../utils/utils";
import {FormattedMessage} from "react-intl";
import {Button, Popover, PopoverBody, UncontrolledPopover} from "reactstrap";
import {Modal} from "../Modal";
import {getIndicator, getIndicatorById, getIndicatorById4FakeTable, getOrderStatusName} from "../../Orders/OrderCommon";
import FontAwesome from "react-fontawesome";
import {Checkbox} from "../form-control";
import collectionColumnViewService from "../../../services/collectionColumnViewService";
import orderDeliveryService from "../../../services/orderDeliveryService";
import {WaitingStatus} from "../../common/Statuses";
import {Preloader} from "../Preloader";
import {VEHICLE_BODY_TYPE} from "../../../constants/staticData";
import LogisticPopupModal from "../LogisticPopupModal";
import moment from "moment";
import AppStore from "../../../stores/appStore";
import {DATE_FORMAT} from "../../../constants/global";

const TableTrackingOrders = ({
                                 items,
                                 openHistoryChanges,
                                 onChangeNotificationStatus,
                                 onClickNavToOrder,
                                 openChangeManagerModal,
                                 openChangeOwnerModal,
                                 openLogisticPopupModal,
                                 openModal,
                                 isTrackingFullBlockView,
                                 pagination,
                                 loaded,
                                 onSearch,
                                 searchAction,
                                 searchKeyDown,
                                 searchValue,
                                 store
                             }) => {
    const context = "table-orders"
    const tableRef = useRef(null)
    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [loadedData, setLoadedData] = useState(false)
    const [updateDataLoader, setUpdateDataLoader] = useState(true)
    const [selectedItem, setSelectedItem] = useState()


    useEffect(() => {
    }, [tableRef.current])

    useEffect(() => {
        if (data?.length > 0) {
            setLoadedData(true)
            // setUpdateDataLoader(false)
        } else {
            setLoadedData(false)
        }
    }, [data])


    const [columns, setColumns] = useState([])
    const [columnsModal, setColumnsModal] = useState([])
    const [isShowFullScreen, setIsShowFullScreen] = useState(false)
    const scheme = [
        'pointOfPickupReadyPlan',
        'pointOfPickupReadyFact',
        'pointOfPickupLoadPlan',
        'pointOfPickupLoadFact',
        'pointOfPickupDeparturePlan',
        'pointOfPickupDepartureFact',

        'invoiceDate',
        'invoicePaymentDate',
        'transitPoints',

        'customsClearanceArrivalPlan',
        'customsClearanceArrivalFact',
        'customsClearanceDeparturePlan',
        'customsClearanceDepartureFact',

        'pointOfDestinationArrivalPlan',
        'pointOfDestinationArrivalFact',

        'deliveryToRecipientArrivalPlan',
        'deliveryToRecipientArrivalFact',

        'statusId'
    ]
    const [activeScheme, setActiveScheme] = useState([])

    const DateTrackingInputColumn = (props) => {
        const {
            rowData,
            rowIndex,
            name = '',
            focus,
            active,
            addId,
            data
        } = props
        const [idField, setIdField] = useState(`element-table-${rowIndex}-${name}`)
        const [idFieldLabel, setIdFieldLabel] = useState(`element-table-label-${rowIndex}-${name}`)

        useEffect(() => {
            setIdField(`element-table-${rowIndex}-${name}_${addId}`)
            setIdFieldLabel(`element-table-label-${rowIndex}-${name}_${addId}`)
        }, [name, addId])

        useEffect(() => {
            if (focus) {
                let rowActiveIndex = 0;
                if (rowData?.orderDeliveryRequestGroup?.cargoInfo?.containers) {
                    rowActiveIndex = rowData?.orderDeliveryRequestGroup?.cargoInfo?.containers?.findIndex(cargo => cargo.idCargo === data[rowIndex].idCargo)
                }
                if (rowData?.orderDeliveryRequestGroup?.cargoInfo?.generals) {
                    rowActiveIndex = rowData?.orderDeliveryRequestGroup?.cargoInfo?.generals?.findIndex(cargo => cargo.idCargo === data[rowIndex].idCargo)
                }
                setSelectedItem({
                    index: rowIndex,
                    id: rowData?.orderDeliveryRequestGroup?.id,
                    activeColumn: name,
                    activeRow: rowActiveIndex
                })
                tableRef.current?.setActiveCell(null)
                tableRef.current?.setSelection(null)
            }
        }, [focus]);

        return <div
            className={`date-readonly date-${rowData?.indicator}`}
        >
            <div
                id={idField}
                className={"d-flex h-100 align-items-center"}
            >
                {(!rowData?.date || rowData?.date?.length === 0) ? "-" : ""}{rowData?.date ? moment(rowData?.date).format(AppStore.userLang === "ru" ? "DD/MM/YYYY" : DATE_FORMAT[AppStore.userLang][0]) : ""}
            </div>
            {document.getElementById(idField) && active && rowData?.name &&
                <Popover
                    className={addId ? "z-index-9999 blue-popover" : "blue-popover"}
                    placement="top"
                    isOpen={active}
                    target={idField}>
                    <PopoverBody>
                        <div>{getExistLangValue(rowData?.name)}</div>
                    </PopoverBody>
                </Popover>
            }

        </div>
    }


    const TransitDateColumn = (props) => {
        const {
            rowData,
            rowIndex,
            name = '',
            focus,
            active,
            addId,
            data = []
        } = props
        const [idField, setIdField] = useState(`element-table-${rowIndex}-${name}`)
        const [idFieldLabel, setIdFieldLabel] = useState(`element-table-label-${rowIndex}-${name}`)
        const [value, setValue] = useState("-")
        const [hint, setHint] = useState()

        useEffect(() => {
            setIdField(`element-table-${rowIndex}-${name}_${addId}`)
            setIdFieldLabel(`element-table-label-${rowIndex}-${name}_${addId}`)
        }, [name, addId])

        useEffect(() => {
            if (isArray(rowData) && rowData?.length > 0) {
                const firstValue = rowData[0];
                let lastValue = null;
                if (rowData.length > 1) {
                    lastValue = rowData[rowData.length - 1];
                }
                setValue(`${firstValue?.arrival?.plan ? moment(firstValue?.arrival?.plan).format(AppStore.userLang === "ru" ? "DD/MM/YYYY" : DATE_FORMAT[AppStore.userLang][0]) : ""} ${lastValue !== null ? "..." : ""} ${lastValue !== null && lastValue?.departure?.plan ? moment(lastValue?.departure?.plan).format(AppStore.userLang === "ru" ? "DD/MM/YYYY" : DATE_FORMAT[AppStore.userLang][0]) : ""}`);
                setHint(prepareValue(rowData));
            }
        }, [rowData])

        useEffect(() => {
            if (focus) {
                if (isArray(rowData) && rowData?.length > 0) {
                    const firstValue = rowData[0];
                    let rowActiveIndex = 0;
                    if (firstValue?.orderDeliveryRequestGroup?.cargoInfo?.containers) {
                        rowActiveIndex = firstValue?.orderDeliveryRequestGroup?.cargoInfo?.containers?.findIndex(cargo => cargo.idCargo === data[rowIndex].idCargo)
                    }
                    if (rowData?.orderDeliveryRequestGroup?.cargoInfo?.generals) {
                        rowActiveIndex = firstValue?.orderDeliveryRequestGroup?.cargoInfo?.generals?.findIndex(cargo => cargo.idCargo === data[rowIndex].idCargo)
                    }
                    setSelectedItem({
                        index: rowIndex,
                        id: firstValue?.orderDeliveryRequestGroup?.id,
                        activeColumn: 'pointOfPickupReadyPlan',
                        activeRow: rowActiveIndex
                    })
                    tableRef.current?.setActiveCell(null)
                    tableRef.current?.setSelection(null)
                }
            }
        }, [focus]);

        const prepareValue = (value) => {
            if (isArray(value) && value?.length > 0) {
                return (<div>
                    {value?.map((item, index) => (<div className={`${index !== 0 ? "mt-2" : ""}`} key={index}>
                        <div>{getExistLangValue(item?.name)}</div>
                        <div><FormattedMessage
                            id={"tableTracking.arrival"}/>{": "}{item?.arrival?.plan ? moment(item?.arrival?.plan).format(AppStore.userLang === "ru" ? "DD/MM/YYYY" : DATE_FORMAT[AppStore.userLang][0]) : "-"}{" / "}{item?.arrival?.fact ? moment(item?.arrival?.fact).format(AppStore.userLang === "ru" ? "DD/MM/YYYY" : DATE_FORMAT[AppStore.userLang][0]) : "-"}
                        </div>
                        <div><FormattedMessage
                            id={"tableTracking.departure"}/>{": "}{item?.departure?.plan ? moment(item?.departure?.plan).format(AppStore.userLang === "ru" ? "DD/MM/YYYY" : DATE_FORMAT[AppStore.userLang][0]) : "-"}{" / "}{item?.departure?.fact ? moment(item?.departure?.fact).format(AppStore.userLang === "ru" ? "DD/MM/YYYY" : DATE_FORMAT[AppStore.userLang][0]) : "-"}
                        </div>
                    </div>))}
                </div>)
            }
            return "-"
        }

        return <div style={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            padding: "5px",
            fontSize: "12px",
            lineHeight: "14px"
        }}>
            <div className={"d-flex align-items-center h-100"} id={idField}>
                {value}
            </div>
            {document.getElementById(idField) && active && hint &&
                <Popover
                    className={addId ? "z-index-9999 blue-popover" : "blue-popover width-custom"}
                    placement="top"
                    isOpen={active || focus}
                    target={idField}>
                    <PopoverBody>
                        <div>{hint}</div>
                    </PopoverBody>
                </Popover>
            }
        </div>
    }

    const StatusColumn = React.memo((props) => {
        const {
            rowData,
        } = props

        return (
            <div style={{padding: "5px", fontSize: "12px", lineHeight: "14px"}}>
                <div
                    className={`status-label status-label-${rowData.toString().toLowerCase()}`}>{getOrderStatusName(rowData)}</div>
            </div>
        )
    })

    const getTrackingDateKeyColumn = (key, mapName, addId = "") => {
        return keyColumn(key, {
            keepFocus: true,
            component: (p) => <DateTrackingInputColumn {...p} data={data} mapName={mapName} addId={addId}
                                                       name={key}/>,
            title: <FormattedMessage id={`orderTable.header.${key}`}/>,
            minWidth: 120,
            copyValue: ({rowData}) => onCopyValueDateTracking(rowData),
            pasteValue: ({
                             rowData,
                             value,
                             rowIndex
                         }) => rowData,
            disabled: false
        })
    }

    const getTransitDateKeyColumn = (key, addId = "") => {
        return keyColumn(key, {
            keepFocus: true,
            component: (p) => <TransitDateColumn {...p} data={data} addId={addId}
                                                 name={key}/>,
            title: <FormattedMessage id={`orderTable.header.${key}`}/>,
            minWidth: 180,
            copyValue: ({rowData}) => onCopyValueDateTracking(rowData),
            pasteValue: ({
                             rowData,
                             value,
                             rowIndex
                         }) => rowData,
            disabled: false
        })
    }


    const getStatusColumn = (key, addId = "") => {
        return keyColumn(key, {
            component: (p) => <StatusColumn {...p} addId={addId} name={key}/>,
            title: <FormattedMessage id={`orderTable.header.${key}`}/>,
            minWidth: 200,
            copyValue: ({rowData}) => onCopyValueText(rowData),
            pasteValue: ({
                             rowData,
                             value,
                             rowIndex
                         }) => rowData,
            disabled: true
        })
    }


    const initColumns = (key = '') => {
        return [
            getTrackingDateKeyColumn('pointOfPickupReadyPlan', 'pointOfPickup.ready.plan', key),
            getTrackingDateKeyColumn('pointOfPickupReadyFact', 'pointOfPickup.ready.fact', key),
            getTrackingDateKeyColumn('pointOfPickupLoadPlan', 'pointOfPickup.load.plan', key),
            getTrackingDateKeyColumn('pointOfPickupLoadFact', 'pointOfPickup.load.fact', key),
            getTrackingDateKeyColumn('pointOfPickupDeparturePlan', 'pointOfPickup.departure.plan', key),
            getTrackingDateKeyColumn('pointOfPickupDepartureFact', 'pointOfPickup.departure.fact', key),

            getTrackingDateKeyColumn('invoiceDate', 'invoiceDate', key),
            getTrackingDateKeyColumn('invoicePaymentDate', 'invoicePaymentDate', key),

            getTransitDateKeyColumn('transitPoints', key),

            getTrackingDateKeyColumn('customsClearanceArrivalPlan', 'customsClearance.arrival.plan', key),
            getTrackingDateKeyColumn('customsClearanceArrivalFact', 'customsClearance.arrival.fact', key),
            getTrackingDateKeyColumn('customsClearanceDeparturePlan', 'customsClearance.departure.plan', key),
            getTrackingDateKeyColumn('customsClearanceDepartureFact', 'customsClearance.departure.fact', key),

            getTrackingDateKeyColumn('pointOfDestinationArrivalPlan', 'pointOfDestination.arrival.plan', key),
            getTrackingDateKeyColumn('pointOfDestinationArrivalFact', 'pointOfDestination.arrival.fact', key),

            getTrackingDateKeyColumn('deliveryToRecipientArrivalPlan', 'deliveryToRecipientDate.plan', key),
            getTrackingDateKeyColumn('deliveryToRecipientArrivalFact', 'deliveryToRecipientDate.fact', key),

            getStatusColumn('statusId', key),
            /*getActionColumn('actions', key),*/
        ].filter(item => item !== null);
    }
    const initColumnsModal = () => {
        return initColumns('modal')
    }

    const handlerResponseViews = (res) => {
        const result = []
        for (let item of scheme) {
            let itemsServer = res.data ? res.data.items : [];
            if (itemsServer.findIndex(i => i?.columnName === item) !== -1) {
                const elem = itemsServer.find(i => i?.columnName === item);
                result.push({name: elem.columnName, enabled: elem.enabled})
            } else
                result.push({name: item, enabled: true})
        }
        setActiveScheme(result)
    }

    const initScheme = () => {
        collectionColumnViewService.getByContext(context).then(res => {
            handlerResponseViews(res)
        })
    }

    useEffect(() => {
        if (loaded === true && data.length > 0) {
            setColumns(initColumns())
            setColumnsModal(initColumnsModal())
            /*initScheme()*/
            setIsLoading(false)
        }
    }, [loaded, data])

    useEffect(() => {
        setColumns(initColumns())
        setColumnsModal(initColumnsModal())
    }, [activeScheme])

    const onClickLayerCheckboxScheme = (name) => {
        const cloned = cloneDeep(activeScheme);
        const index = cloned.findIndex((value, index) => value.name === name);
        cloned[index].enabled = !cloned[index].enabled;
        collectionColumnViewService.updateView(context, name, cloned[index].enabled).then(res => {
            handlerResponseViews(res)
        })
    }


    const prepareTrackingInfo = async (trackingInfo, id, status, requestGroup) => {
        const result = {
            pointOfPickupReadyPlan: {date: undefined, name: ''},
            pointOfPickupReadyFact: {date: undefined, name: ''},
            pointOfPickupLoadPlan: {date: undefined, name: ''},
            pointOfPickupLoadFact: {date: undefined, name: ''},
            pointOfPickupDeparturePlan: {date: undefined, name: ''},
            pointOfPickupDepartureFact: {date: undefined, name: ''},
            invoiceDate: {date: undefined, name: ''},
            invoicePaymentDate: {date: undefined, name: ''},
            transitPoints: [],
            customsClearanceArrivalPlan: {date: undefined, name: ''},
            customsClearanceArrivalFact: {date: undefined, name: ''},
            customsClearanceDeparturePlan: {date: undefined, name: ''},
            customsClearanceDepartureFact: {date: undefined, name: ''},
            pointOfDestinationArrivalPlan: {date: undefined, name: ''},
            pointOfDestinationArrivalFact: {date: undefined, name: ''},
            deliveryToRecipientArrivalPlan: {date: undefined, name: ''},
            deliveryToRecipientArrivalFact: {date: undefined, name: ''},
        };
        const indicator = await getIndicator(null, status, trackingInfo)
        if (trackingInfo?.transitPoints?.length > 0) {
            for (let transitPoint of trackingInfo?.transitPoints) {
                switch (transitPoint.typeTracking) {
                    case "POINT_OF_PICKUP":
                        result.pointOfPickupReadyPlan.date = transitPoint.ready?.plan;
                        result.pointOfPickupReadyPlan.name = transitPoint.name;
                        result.pointOfPickupReadyPlan.orderDeliveryRequestGroup = requestGroup;

                        result.pointOfPickupReadyFact.date = transitPoint.ready?.fact;
                        result.pointOfPickupReadyFact.name = transitPoint.name;
                        result.pointOfPickupReadyFact.orderDeliveryRequestGroup = requestGroup;
                        result.pointOfPickupReadyFact.indicator = getIndicatorById4FakeTable(transitPoint.ready?.plan, transitPoint.ready?.fact)

                        result.pointOfPickupLoadPlan.date = transitPoint.load?.plan;
                        result.pointOfPickupLoadPlan.name = transitPoint.name;
                        result.pointOfPickupLoadPlan.orderDeliveryRequestGroup = requestGroup;

                        result.pointOfPickupLoadFact.date = transitPoint.load?.fact;
                        result.pointOfPickupLoadFact.name = transitPoint.name;
                        result.pointOfPickupLoadFact.indicator = getIndicatorById4FakeTable(transitPoint.load?.plan, transitPoint.load?.fact)

                        result.pointOfPickupDeparturePlan.date = transitPoint.departure?.plan;
                        result.pointOfPickupDeparturePlan.name = transitPoint.name;
                        result.pointOfPickupDeparturePlan.orderDeliveryRequestGroup = requestGroup;

                        result.pointOfPickupDepartureFact.date = transitPoint.departure?.fact;
                        result.pointOfPickupDepartureFact.name = transitPoint.name;
                        result.pointOfPickupDepartureFact.indicator = getIndicatorById4FakeTable(transitPoint.departure?.plan, transitPoint.departure?.fact)
                        break;
                    case "INVOICE_DATE":
                        result.invoiceDate.date = transitPoint.singleDate;
                        result.invoiceDate.orderDeliveryRequestGroup = requestGroup;
                        break;
                    case "INVOICE_PAYMENT_DATE":
                        result.invoicePaymentDate.date = transitPoint.singleDate;
                        result.invoicePaymentDate.orderDeliveryRequestGroup = requestGroup;
                        result.invoicePaymentDate.indicator = getIndicatorById4FakeTable(trackingInfo.transitPoints?.filter(tp => tp.typeTracking === "INVOICE_DATE")?.singleDate, transitPoint.singleDate)
                        break;
                    case "POINT_OF_CUSTOMS_CLEARANCE":
                        result.customsClearanceArrivalPlan.date = transitPoint.arrival?.plan;
                        result.customsClearanceArrivalPlan.orderDeliveryRequestGroup = requestGroup;

                        result.customsClearanceArrivalFact.date = transitPoint.arrival?.fact;
                        result.customsClearanceArrivalFact.orderDeliveryRequestGroup = requestGroup;
                        result.customsClearanceArrivalFact.indicator = getIndicatorById4FakeTable(transitPoint.arrival?.plan, transitPoint.arrival?.fact)

                        result.customsClearanceDeparturePlan.date = transitPoint.departure?.plan;
                        result.customsClearanceDeparturePlan.orderDeliveryRequestGroup = requestGroup;

                        result.customsClearanceDepartureFact.date = transitPoint.departure?.fact;
                        result.customsClearanceDepartureFact.orderDeliveryRequestGroup = requestGroup;
                        result.customsClearanceDepartureFact.indicator = getIndicatorById4FakeTable(transitPoint.departure?.plan, transitPoint.departure?.fact)
                        break;
                    case "POINT_OF_DESTINATION":
                        result.pointOfDestinationArrivalPlan.date = transitPoint.arrival?.plan;
                        result.pointOfDestinationArrivalPlan.name = transitPoint.name;
                        result.pointOfDestinationArrivalPlan.orderDeliveryRequestGroup = requestGroup;

                        result.pointOfDestinationArrivalFact.date = transitPoint.arrival?.fact;
                        result.pointOfDestinationArrivalFact.name = transitPoint.name;
                        result.pointOfDestinationArrivalFact.orderDeliveryRequestGroup = requestGroup;
                        result.pointOfDestinationArrivalFact.indicator = getIndicatorById4FakeTable(transitPoint.arrival?.plan, transitPoint.arrival?.fact)

                        break;
                    case "POINT_OF_DELIVERY_TO_RECIPIENT":
                        result.deliveryToRecipientArrivalPlan.date = transitPoint.arrival?.plan;
                        result.deliveryToRecipientArrivalPlan.name = transitPoint.name;
                        result.deliveryToRecipientArrivalPlan.orderDeliveryRequestGroup = requestGroup;


                        result.deliveryToRecipientArrivalFact.date = transitPoint.arrival?.fact;
                        result.deliveryToRecipientArrivalFact.name = transitPoint.name;
                        result.deliveryToRecipientArrivalFact.orderDeliveryRequestGroup = requestGroup;
                        result.deliveryToRecipientArrivalFact.indicator = getIndicatorById4FakeTable(transitPoint.arrival?.plan, transitPoint.arrival?.fact)

                        break;
                    default:
                        result.transitPoints.push({...transitPoint, orderDeliveryRequestGroup: requestGroup});
                        break;
                }
            }
        } else {
            const pointOfPickup = trackingInfo?.pointOfPickup;
            if (pointOfPickup) {
                result.pointOfPickupReadyPlan.date = pointOfPickup.ready?.plan;
                result.pointOfPickupReadyPlan.name = pointOfPickup.name;
                result.pointOfPickupReadyPlan.orderDeliveryRequestGroup = requestGroup;

                result.pointOfPickupReadyFact.date = pointOfPickup.ready?.fact;
                result.pointOfPickupReadyFact.name = pointOfPickup.name;
                result.pointOfPickupReadyFact.orderDeliveryRequestGroup = requestGroup;
                result.pointOfPickupReadyFact.indicator = getIndicatorById(indicator, 'indicator.pointOfPickup.ready', 1) ? "error" : getIndicatorById(indicator, 'indicator.pointOfPickup.ready', 2) ? "warning" : ""

                result.pointOfPickupLoadPlan.date = pointOfPickup.load?.plan;
                result.pointOfPickupLoadPlan.name = pointOfPickup.name;
                result.pointOfPickupLoadPlan.orderDeliveryRequestGroup = requestGroup;

                result.pointOfPickupLoadFact.date = pointOfPickup.load?.fact;
                result.pointOfPickupLoadFact.name = pointOfPickup.name;
                result.pointOfPickupLoadFact.orderDeliveryRequestGroup = requestGroup;
                result.pointOfPickupLoadFact.indicator = getIndicatorById(indicator, 'indicator.pointOfPickup.load', 1) ? "error" : getIndicatorById(indicator, 'indicator.pointOfPickup.load', 2) ? "warning" : ""

                result.pointOfPickupDeparturePlan.date = pointOfPickup.departure?.plan;
                result.pointOfPickupDeparturePlan.name = pointOfPickup.name;
                result.pointOfPickupDeparturePlan.orderDeliveryRequestGroup = requestGroup;

                result.pointOfPickupDepartureFact.date = pointOfPickup.departure?.fact;
                result.pointOfPickupDepartureFact.name = pointOfPickup.name;
                result.pointOfPickupDepartureFact.orderDeliveryRequestGroup = requestGroup;
                result.pointOfPickupDepartureFact.indicator = getIndicatorById(indicator, 'indicator.pointOfPickup.departure', 1) ? "error" : getIndicatorById(indicator, 'indicator.pointOfPickup.departure', 2) ? "warning" : ""
            }
            const invoiceDate = trackingInfo?.invoiceDate;
            if (invoiceDate) {
                result.invoiceDate.date = invoiceDate?.date?.date;
                result.invoiceDate.orderDeliveryRequestGroup = requestGroup;
            }
            const invoicePaymentDate = trackingInfo?.invoicePaymentDate;
            if (invoicePaymentDate) {
                result.invoicePaymentDate.date = invoicePaymentDate?.date?.date;
                result.invoicePaymentDate.orderDeliveryRequestGroup = requestGroup;
                result.invoicePaymentDate.indicator = getIndicatorById(indicator, 'indicator.invoicePaymentDate', 1) ? "error" : getIndicatorById(indicator, 'indicator.invoicePaymentDate', 2) ? "warning" : ""
            }
            const customsClearance = trackingInfo?.customsClearance;
            if (customsClearance) {
                result.customsClearanceArrivalPlan.date = customsClearance?.arrival?.plan;
                result.customsClearanceArrivalPlan.orderDeliveryRequestGroup = requestGroup;

                result.customsClearanceArrivalFact.date = customsClearance?.arrival?.fact;
                result.customsClearanceArrivalFact.orderDeliveryRequestGroup = requestGroup;
                result.customsClearanceArrivalFact.indicator = getIndicatorById(indicator, 'indicator.customsClearance.arrival', 1) ? "error" : getIndicatorById(indicator, 'indicator.customsClearance.arrival', 2) ? "warning" : ""

                result.customsClearanceDeparturePlan.date = customsClearance?.departure?.plan;
                result.customsClearanceDeparturePlan.orderDeliveryRequestGroup = requestGroup;

                result.customsClearanceDepartureFact.date = customsClearance?.departure?.fact;
                result.customsClearanceDepartureFact.orderDeliveryRequestGroup = requestGroup;
                result.customsClearanceDepartureFact.indicator = getIndicatorById(indicator, 'indicator.customsClearance.departure', 1) ? "error" : getIndicatorById(indicator, 'indicator.customsClearance.departure', 2) ? "warning" : ""
            }
            const pointOfDestination = trackingInfo?.pointOfDestination;
            if (pointOfDestination) {
                result.pointOfDestinationArrivalPlan.date = pointOfDestination?.arrival?.plan;
                result.pointOfDestinationArrivalPlan.name = pointOfDestination?.name;
                result.pointOfDestinationArrivalPlan.orderDeliveryRequestGroup = requestGroup;

                result.pointOfDestinationArrivalFact.date = pointOfDestination?.arrival?.fact;
                result.pointOfDestinationArrivalFact.name = pointOfDestination?.name;
                result.pointOfDestinationArrivalFact.orderDeliveryRequestGroup = requestGroup;
                result.pointOfDestinationArrivalFact.indicator = getIndicatorById(indicator, 'indicator.pointOfDestination.arrival', 1) ? "error" : getIndicatorById(indicator, 'indicator.pointOfDestination.arrival', 2) ? "warning" : ""
            }
            const pointOfDeliveryToRecipient = trackingInfo?.deliveryToRecipientDate;
            if (pointOfDeliveryToRecipient) {
                result.deliveryToRecipientArrivalPlan.date = pointOfDeliveryToRecipient?.date?.plan;
                result.deliveryToRecipientArrivalPlan.name = pointOfDeliveryToRecipient?.name;
                result.deliveryToRecipientArrivalPlan.orderDeliveryRequestGroup = requestGroup;

                result.deliveryToRecipientArrivalFact.date = pointOfDeliveryToRecipient?.date?.fact;
                result.deliveryToRecipientArrivalFact.name = pointOfDeliveryToRecipient?.name;
                result.deliveryToRecipientArrivalFact.orderDeliveryRequestGroup = requestGroup;
                result.deliveryToRecipientArrivalFact.indicator = getIndicatorById(indicator, 'indicator.deliveryToRecipientDate', 1) ? "error" : getIndicatorById(indicator, 'indicator.deliveryToRecipientDate', 2) ? "warning" : ""
            }

        }
        return result
    }

    const getNameCargo = (itemTracking, trackingInfo) => {
        const id = itemTracking.orderDeliveryRequestGroup?.id;
        const cargoInfo = itemTracking.orderDeliveryRequestGroup?.cargoInfo;
        const order = itemTracking.orderDeliveryRequestGroup?.order;
        const internalId = itemTracking.orderDeliveryRequestGroup?.internalId
        const cargo = (cargoInfo?.containers ? cargoInfo.containers : cargoInfo?.generals ? cargoInfo.generals : [order?.cargo?.vehicle]).filter(cargo => cargo?.idCargo === trackingInfo?.idCargo)[0]
        if (cargoInfo?.containers) {
            const types = {
                1: "20\"",
                2: "40\"",
                3: "40\"HC",
            }
            return `${id} / ${internalId ? internalId : '-'} / ${cargo?.containerId ? cargo.containerId : "-"} - ${get(types, cargo?.typeId)}`
        }
        if (cargoInfo?.generals) {
            let name = translate("form.field.general")
            if (itemTracking.orderDeliveryRequestGroup?.awbNumber)
                name = `${itemTracking.orderDeliveryRequestGroup?.awbNumber}`
            if (itemTracking.orderDeliveryRequestGroup?.containerNumber)
                name = `${itemTracking.orderDeliveryRequestGroup?.containerNumber}`
            if (itemTracking.orderDeliveryRequestGroup?.bol)
                name = `${itemTracking.orderDeliveryRequestGroup?.bol}`
            return id + " / "+ (internalId ? internalId : '-') +' / ' + name
            if (cargo?.typeId !== undefined) {
                const typeId = {
                    1: "cargoType.box",
                    2: "cargoType.pallet",
                    3: "cargoType.cube"
                }
                let formatSize = `${cargo?.length ? cargo?.length : '-'} x ${cargo?.width ? cargo?.width : '-'} x ${cargo?.height ? cargo?.height : '-'} (${cargo?.sizeUnit}) - ${cargo?.weight} ${cargo?.weightUnit}`
                if (cargo.typeId === 3) {
                    formatSize = `${cargo.cubeVolume ? cargo.cubeVolume : "-"} ${cargo.sizeUnit} - ${cargo?.weight} ${cargo?.weightUnit}`
                }
                return `${id} / ${internalId ? internalId : ''} / ${translate({id: `${typeId[cargo.typeId]}`})} - ${cargo?.amount} ${translate({id: "detailsOfCalculation.pieces"})} - ${formatSize}`
            }
        }
        if (order?.cargo?.vehicle) {
            const bodyType = VEHICLE_BODY_TYPE.find(v => v.value === cargo?.bodyType)?.message
            return `${id} / ${internalId ? internalId : ''}  / ${translate({id: `cargoType.car`})} - ${cargo?.type?.name ? getExistLangValue(cargo?.type?.name) : ''} - ${translate({id: `constants.${bodyType}`})}`
        }
        return "-"
    }

    const prepareItems = (itemsArray) => {
        const items = itemsArray;
        const lang = getLangInStorage();
        const ruLang = 'ru';
        setUpdateDataLoader(true)
        orderDeliveryService.getTrackingInfo4RequestGroups(items.map(item => item.id)).then(async res => {
            if (res.code === 200) {
                const array = [];
                for (let itemTracking of res.data) {
                    for (let trackingInfoItem of itemTracking?.trackingInfoItems) {
                        array.push({
                            nameCargo: getNameCargo(itemTracking, trackingInfoItem),
                            idCargo: trackingInfoItem?.idCargo,
                            orderId: itemTracking.orderDeliveryRequestGroup?.id,
                            orderDeliveryRequestGroup: itemTracking.orderDeliveryRequestGroup,
                            statusId: trackingInfoItem?.status,
                            ...(await prepareTrackingInfo(trackingInfoItem?.trackingInfo, itemTracking.orderDeliveryRequestGroup?.id, trackingInfoItem?.status, itemTracking.orderDeliveryRequestGroup))
                        })
                    }
                }
                setData(array);
            }
            setUpdateDataLoader(false)
        })


    }

    useEffect(() => {
        if (items && isArray(items) && loaded === true) {
            prepareItems(items)
        }
    }, [items, loaded])

    const getActions = (item, index) => {
        return {
            orderNumber: item.orderId,
            canEdit: isTrackingFullBlockView,
            onEditClick: (id) => {
                openModal(index);
            },
            onPopupEditClick: () => {
                openLogisticPopupModal(item.orderId)
            },
           /* onPopupChangeOwnerClick: () => {
                openChangeOwnerModal(index)
            },*/
           /* onPopupChangeManagerClick: () => {
                openChangeManagerModal(index)
            },*/
            onClickToNavOrder: () => {
                onClickNavToOrder(item)
            },
            onChangeNotificationStatus: () => onChangeNotificationStatus(item),
            openHistoryChanges: () => openHistoryChanges(index)
        }
    }
    const GutterColumnModal = (props) => {
        const {rowIndex, isModal} = props
        const [onHover, setOnHover] = useState(false)
        const [idField, setIdField] = useState(`gutter-cell-${rowIndex}-modal`)

        return <div className={"dsg-cell-gutter-custom"}>
            <div id={idField}
                 onPointerEnter={() => setOnHover(true)}
                 onPointerLeave={() => setOnHover(false)}
                 className={"dsg-cell-gutter-custom__data"}>
                <div>
                    {data[rowIndex]?.nameCargo}
                </div>
            </div>
            {document.getElementById(idField) &&
                <Popover
                    className={"z-index-9999"}
                    placement={"top"}
                    isOpen={onHover}
                    target={idField}>
                    <PopoverBody>
                        <div>
                            {data[rowIndex]?.nameCargo}
                        </div>
                    </PopoverBody>
                </Popover>
            }

        </div>
    }
    const GutterColumn = (props) => {
        const {rowIndex} = props
        const [onHover, setOnHover] = useState(false)
        const [idField, setIdField] = useState(`gutter-cell-${rowIndex}`)


        return <div className={"dsg-cell-gutter-custom"}>
            <div id={idField}
                 onPointerEnter={() => setOnHover(true)}
                 onPointerLeave={() => setOnHover(false)}
                 className={"dsg-cell-gutter-custom__data"}>
                <div>
                    {data[rowIndex]?.nameCargo}
                </div>
            </div>
            {document.getElementById(idField) &&
                <Popover
                    isOpen={onHover}
                    target={idField}>
                    <PopoverBody>
                        <div>
                            {data[rowIndex]?.nameCargo}
                        </div>
                    </PopoverBody>
                </Popover>
            }

        </div>
    }

    const body = (isModal = false) => {
        if (data.length === 0) return null
        if (loadedData === false) return null
        return <DynamicDataSheetGrid
            ref={tableRef}
            className={"table-orders"}
            columns={isModal === true ? columnsModal : columns}
            onChange={() => {
            }}
            addRowsComponent={createAddRowsComponent()}
            gutterColumn={{
                basis: 240,
                component: (p) => isModal === true ? <GutterColumnModal {...p} /> : <GutterColumn {...p} />
            }}
            disableExpandSelection={true}
            value={data}
            height={isModal === true ? (window.innerHeight - 160) : 800}
            headerRowHeight={80}
            contextMenuComponent={React.memo((props) => {
                return <ContextMenu {...props}
                                    actionsCustom={() => data.map((item, index) => getActions(item, index))}
                />
            })
            }
            rowHeight={isModal === true ? Math.max(Math.min((window.innerHeight - 200 - 60) / data.length, 90), 40) : 40}
        />
    }

    const fullScreenTitle = () => {
        return <div>
            <div className={"d-flex actions-table-orders"}>
                <div className={"d-flex"} style={{flex: '1 1 80%'}}>
                    <input
                        className="search-bar"
                        onChange={e => onSearch(e)}
                        onKeyDown={e => searchKeyDown(e)}
                        value={searchValue}
                        placeholder={translate('deliveryOrders.orderList.searchPlaceholder')}
                        style={{
                            padding: '12px 12px 12px 45px',
                            height: '48px',
                            borderRadius: '3px',
                        }}
                    />
                    <FontAwesome name="search"
                                 style={{position: 'absolute', top: '29px', right: '553px', cursor: 'pointer'}}
                                 onClick={e => this.searchAction(e)}/>
                    <Button className={"btn-primary-new"} onClick={() => searchAction()}><FormattedMessage
                        id={"deliveryOrders.orderList.searchBtnTitle"}/></Button>
                </div>
                {/* <div className={"ml-3"}>
                    <FontAwesome id={"order-table-filter-layers-modal"} name={"cog"}/>
                    <UncontrolledPopover
                        placement="bottom"
                        target="order-table-filter-layers-modal"
                        trigger="legacy"
                        className={"z-index-9999"}
                    >
                        <PopoverBody>
                            <div className={"filter-view-layers-body"}>
                                {activeScheme.map(columnView => {
                                    return <div className={"d-flex mt-2"}>
                                        <Checkbox checked={columnView?.enabled}
                                                  onChange={() => onClickLayerCheckboxScheme(columnView?.name)}/>
                                        {" "}<FormattedMessage id={`orderTable.header.${columnView?.name}`}/>
                                    </div>
                                })}
                            </div>
                        </PopoverBody>
                    </UncontrolledPopover>
                </div>*/}
                <div className={"d-block ml-3"}
                     onClick={() => setIsShowFullScreen(false)}>
                    <FontAwesome name={"compress"}/>
                </div>
            </div>
        </div>
    }

    const onCloseModal = () => {
        setSelectedItem(undefined);
        setUpdateDataLoader(true)
        store.reloadList();
    }

    return <div>
        <Preloader isShow={updateDataLoader === true}/>
        {data.map((row, index) => {
            return <div key={index}>
                <LogisticPopupModal
                    activeColumn={selectedItem?.activeColumn}
                    activeRow={selectedItem?.activeRow}
                    isModal={true}
                    viewTable={true}
                    isShow={selectedItem?.index === index}
                    item={row?.orderDeliveryRequestGroup}
                    onClose={() => onCloseModal()}
                    onUpdateTrackingInfo={() => {
                    }}
                    onUpdateTrackingDetails={() => {
                    }}
                />
            </div>
        })}

        <Modal
            className={"table-orders-modal fullscreen-modal"}
            isShow={isShowFullScreen}
            onClose={() => setIsShowFullScreen(false)}
            isModal={true}
            title={fullScreenTitle()}
        >
            {loaded === false ?
                <div>
                    <WaitingStatus/>
                </div> :
                <div>
                    <div>{pagination}</div>
                    <div>{body(true)}</div>
                </div>
            }
        </Modal>
        <div className={"d-block"}>
            <div className={"d-flex actions-table-orders"}>
                <div className={"ml-auto"}>
                    {/*<FontAwesome id={"order-table-filter-layers"} name={"cog"}/>
                    <UncontrolledPopover
                        placement="bottom"
                        target="order-table-filter-layers"
                        trigger="legacy"
                    >
                        <PopoverBody>
                            <div className={"filter-view-layers-body"}>
                                {activeScheme.map(columnView => {
                                    return <div className={"d-flex mt-2"}>
                                        <Checkbox checked={columnView?.enabled}
                                                  onChange={() => onClickLayerCheckboxScheme(columnView?.name)}/>
                                        {" "}<FormattedMessage id={`orderTable.header.${columnView?.name}`}/>
                                    </div>
                                })}
                            </div>
                        </PopoverBody>
                    </UncontrolledPopover>*/}
                </div>
                <div className={"d-block ml-3"}
                     onClick={() => setIsShowFullScreen(true)}>
                    <FontAwesome name={"arrows-alt"}/>
                </div>
            </div>
            <div>

                {loaded === false ?
                    <div>
                        <WaitingStatus/>
                    </div> :
                    <div>
                        <div>{pagination}</div>
                        <div>{body()}</div>
                        <div>{pagination}</div>
                    </div>
                }
            </div>
        </div>
    </div>
};

TableTrackingOrders.propTypes = {};

export default TableTrackingOrders;